import React, { useState, useRef, useEffect } from "react";
import Link from "next/link";
import { useProjections } from "../../_actions/eventsActions";
import { generateSkeletons } from "@/components/lib/Skeletons";
import { PlayIcon } from "@heroicons/react/outline";
import { getStrapiImage } from "@/utils/strapiFunctions";
import Metadata from "@/components/film/Metadata";
import AnchorChip from "@/components/lib/AnchorChip";
import Button from "@/components/actions/Button";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import * as Text from "@/components/text";

export default function OnlineEvents() {
  const {
    data: projections,
    error: projectionsError,
    loading: projectionsLoading,
  } = useProjections({
    online_screenings: {
      start_date: {
        $notNull: true,
      },
    },
  });

  useEffect(() => {
    projections?.data.sort((a, b) => {
      return new Date(a?.attributes?.online_screenings[0]?.start_date) - new Date(b?.attributes?.online_screenings[0]?.start_date);
    });
  }, [projections]);

  return (
    <div className="my-5 grid-cols-2 gap-3 space-y-3 md:grid md:space-y-0">
      {projections?.data.length ? (
        projections.data.map((projection) => (
          <OnlineScreeningCard
            key={projection?.id}
            name={
              projection?.attributes?.peliculas?.data[0]?.attributes?.film_name
            }
            image={getStrapiImage(
              projection?.attributes?.peliculas?.data[0]?.attributes
                ?.film_cover_image
            )}
            directors={projection?.attributes?.peliculas?.data[0]?.attributes?.Directores.map(
              (director) => director?.Director
            )}
            date_from={format(new Date(projection?.attributes?.online_screenings[0]?.start_date), 'd', { locale: es })}
            date_to={format(new Date(projection?.attributes?.online_screenings[0]?.end_date), 'd MMMM', { locale: es })}
            metadata={{
              year: projection?.attributes?.peliculas?.data[0]?.attributes
                ?.film_year[0]?.year,
              duration:
                projection?.attributes?.peliculas?.data[0]?.attributes
                  ?.film_length,
              countries:
                projection?.attributes?.peliculas?.data[0]?.attributes?.countries.map(
                  (country) => country?.countries
                ),
            }}
            film_trailer_link={
              projection?.attributes?.peliculas?.data[0]?.attributes
                ?.film_trailer_link
            }
            view_more={
              projection?.attributes?.peliculas?.data[0]?.attributes
                ?.film_stream_link
            }
            movieLink={`/catalogo/${projection?.attributes?.peliculas?.data[0]?.attributes?.filmSlug}`}
          />
        ))
      ) : (
        <div className="grid-cols-3 md:grid ">{generateSkeletons(3)}</div>
      )}
    </div>
  );
}

export function OnlineEventsCalendar() {
  return (
    <div className="flex flex-col">
      <Text.Body as="p" size="xl">
        Disfruta de la programación en línea entre el 2 y 19 de mayo en&nbsp;
        <a
          href="https://www.nuestrocine.mx"
          target="_blank"
          rel="noreferrer"
          label="Mubi"
        >
          <Text.Body size="xl" as="span" className=" underline ">
            www.nuestrocine.mx
          </Text.Body>&nbsp;
        </a>
      </Text.Body>
      <div className="mt-2">
        <AnchorChip> 2 - 19 mayo</AnchorChip>
      </div>
    </div>
  );
}

function OnlineScreeningCard({
  image = "",
  name = "",
  directors = [],
  film_trailer_link = "",
  date_from = "",
  date_to = "",
  view_more = "",
  movieLink = "",
  metadata = {
    year: "",
    duration: "",
    countries: "",
  },
}) {
  return (
    <div className=" left-0 top-0 z-40 flex h-full items-center gap-3 bg-transparent align-middle lg:gap-4">
      <div className=" aspect-[2/3] min-w-[96px]	max-w-[96px] self-baseline bg-gray-100 lg:h-full lg:min-w-[124px] lg:max-w-[124px]  ">
        <img
          className="h-full max-h-[216px] min-h-[152px] w-full object-cover "
          src={image}
        ></img>
      </div>
      <div className="ml-3 w-full space-y-3 lg:ml-4">
        <Text.Title as="p" size="md">
          {name}
        </Text.Title>
        {date_from ? <div className="flex gap-1">
          <Text.Title as="p" size="sm" className="text-gray-500">
            Del {date_from} al {date_to}
          </Text.Title>
        </div> : null}
        <Text.Body size="md" className=" py-1">
          {directors.join(", ")}
        </Text.Body>

        <Metadata film_metadata={metadata} />

        <div className=" flex gap-1 py-1">
          {film_trailer_link ? (
            <a href={film_trailer_link} target="_blank" rel="noreferrer">
              <Button
                size="sm"
                color="terciary-light"
                label="Ver trailer"
              ></Button>
            </a>
          ) : null}
          {view_more ? (
            <Link
              href={view_more}
              replace={true}
              target="_blank"
              rel="noreferrer"
            >
              <Button
                size="sm"
                color="terciary-dark"
                label="Ver en línea"
                trailingIcon={<PlayIcon className="h-6 w-6" />}
              />
            </Link>
          ) : null}

          <a href={movieLink}>
            <Button size="sm" color="terciary-light" label="Conocer más" />
          </a>
        </div>
      </div>
    </div>
  );
}
